import{useRef as r,useState as t,useCallback as e}from"react";function o({controlledValue:o,defaultValue:n}){const u=void 0!==o,c=r(u),[l,a]=t(n),d=e((r=>{c.current||a(r)}),[]);return[c.current&&u?o:l,d]}export{o as useControlledState};
//# sourceMappingURL=useControlledState.js.map
